import {
  appendStepBlockId,
  startsWithHttp,
  clsx
} from '@epilot/journey-logic-commons'
import type { ReactNode } from 'react'

import { Icon, Button } from '../../components'
import { useResizeDirection } from '../../utils'

import classes from './HyperlinkControl.module.scss'

type Option = {
  value: string
  label: string
}

type HyperlinkControlProps = {
  options: { value: string; label: string }[]
  label: string
  id: string
}

export const HyperlinkControl = ({ options, id }: HyperlinkControlProps) => {
  const [direction, buttonWrapRef] = useResizeDirection()

  const buttons: ReactNode[] = options.map((option: Option, index: number) => {
    const label = option.label
    const value = option.value

    const buttonId = appendStepBlockId(id, label)

    return (
      <Button
        className={classes.button}
        color="primary"
        href={startsWithHttp(value) ? value : `https://${value}`}
        id={buttonId}
        isLink
        key={index}
        label={label}
        rel="noopener"
        rightIcon={<Icon color="primary" name="open_in_new" />}
        target="_blank"
        variant="outlined"
      />
    )
  })

  return (
    <div
      className={clsx(
        classes.buttonWrap,
        direction === 'column' && classes.columnDirection
      )}
      ref={buttonWrapRef}
    >
      {buttons}
    </div>
  )
}
